module.exports = __webpack_public_path__ + "980af4e38809a2b967313ce50ec8f0b4.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/201606_Presse_AVANGA_Sputnika_422KB.jpg
// module id = 570
// module chunks = 0